export default [
    {
        path: '/revenue-group',
        props: true,
        component: () => import('@/views/RevenueGroup'),
    },
];